import { memo } from 'react';

import { FileStatusButton, FileStatusIconErrored, FileStatusTitle } from '@air/feature-file-status/ui';
import { Close } from '@air/next-icons';

import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';

export type DuplicateBoardFailedPanelItemProps = {
  onClear: () => void;
};

export const DuplicateBoardFailedPanelItem = memo(({ onClear }: DuplicateBoardFailedPanelItemProps) => {
  return (
    <PaneItemTW
      avatar={<FileStatusIconErrored />}
      title={<FileStatusTitle>Failed to duplicate board!</FileStatusTitle>}
      buttons={
        <FileStatusButton label="Clear" onClick={() => onClear()}>
          <Close className="size-4" />
        </FileStatusButton>
      }
    />
  );
});

DuplicateBoardFailedPanelItem.displayName = 'DuplicateBoardErrorPanelItem';
